<div class="dialog-header gbg" style="min-width: 255px;">
    <div class="dialog-title fs18">
        Upload: {{ddata.title}}
    </div>
</div>


<form [formGroup]="iForm" name="iForm" (ngSubmit)="onSubmit()" *ngIf="type === 'id0' || type === 'id1' || type === 'id2' || type === 'reg'">
    <div class="dialog-body" style="min-height: 400px !important;" [ngClass]="{'xs-dialog-scroll' : size.xs }">
        <div class="row" *ngIf="!isFileUploaded">
            <div class="col-12 mb-3">
                <table>
                    <tr>
                        <td>
                            <span class="bold c-grey fs12">Supported File Formats: &nbsp;&nbsp;<span class="bold c-danger fs12">.PNG, .JPG, .JPEG, .PDF</span></span>
                        </td>
                    </tr>
                    <tr *ngIf="type !== 'id0' && type !== 'reg'">
                        <td>
                            <span class="bold c-grey fs12"><span class="bold text-red-600 fs14">Scroll down for more ID options</span></span>
                        </td>

                    </tr>
                    <tr *ngIf="type === 'id0' || type === 'reg'">
                        <td>
                            <span class="bold c-grey fs12"><span class="bold text-red-600 fs14">Please take selfie as shown below</span></span>
                        </td>

                    </tr>
                </table>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
              
                <div *ngIf="!isFileUploaded">
                    <mat-form-field appearance="outline" class="wp100 bold"  *ngIf="type !== 'id0' && type !== 'reg'">
                        <mat-select placeholder="Please select the type of ID*" (selectionChange)="onChangeIdType($event)" required>
                            <mat-option *ngFor="let item of clientIdTypeList" [value]="item.id"><span class="fs16 bold c-black">{{item.name}}</span></mat-option>
                        </mat-select>
                    </mat-form-field>
                    <div class="row" style="margin-bottom: 20px;"  *ngIf="type === 'id0' || type === 'reg'">
                        <div class="col-md-12 text-center w-full">
                            <img src="assets/images/selfie.jpg" style="height: 100px;" alt="selfie" class="d-block mx-auto" />
                        </div>
                    </div>

                    <div *ngIf="selectedIdTypeId > 0">
                        <mat-form-field appearance="fill" class="w100" *ngIf="!isFileSelected">
                            <mat-label *ngIf="selectedIdTypeId !== 1">{{selectedIdType}}</mat-label>
                            <mat-label *ngIf="selectedIdTypeId === 1">Licence Front</mat-label>
                            <ngx-mat-file-input formControlName="file" (change)="onFileSelected($event)" placeholder="Basic fill placeholder" accept="image/*,application/pdf" [disabled]="disabled" #fileUpload required></ngx-mat-file-input>
                            <mat-icon matSuffix *ngIf="fileUpload.empty">folder</mat-icon>
                        </mat-form-field>
                        <div class="flex flex-col" *ngIf="isFileSelected">
                            <span class="fs16 bold c-blue">{{selectedIdType}}</span>
                            <div class="flex items-start gap-4">
                                <img *ngIf="isImageSelected" [src]="filePreviewUrl" alt="Selected Image" style="height: 70px !important;" />
                                <img *ngIf="isPdfSelected" src="assets/images/pdf-logo.png" alt="PDF Icon" style="height: 70px !important;" />
                                <button mat-icon-button color="warn" type="button" (click)="clearFile()" aria-label="Delete" class="mt-2">
                                    <mat-icon>remove_circle</mat-icon>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="selectedIdTypeId === 1" class="mt-6">
                        <mat-form-field appearance="fill" class="w100" *ngIf="!isFileSelected2">
                            <mat-label>Licence Back</mat-label>
                            <ngx-mat-file-input formControlName="file2" (change)="onFileSelected2($event)" placeholder="Basic fill placeholder" accept="image/*,application/pdf" [disabled]="disabled" #fileUpload2 required></ngx-mat-file-input>
                            <mat-icon matSuffix *ngIf="fileUpload2.empty">folder</mat-icon>
                        </mat-form-field>
                        <div class="flex flex-col" *ngIf="isFileSelected2">
                            <span class="fs16 bold c-blue">Back side of Driver Licence</span>
                            <div class="flex items-start gap-4">
                                <img *ngIf="isImageSelected2" [src]="filePreviewUrl2" alt="Selected Image" style="height: 70px !important;" />
                                <img *ngIf="isPdfSelected2" src="assets/images/pdf-logo.png" alt="PDF Icon" style="height: 70px !important;" />
                                <button mat-icon-button color="warn" type="button" (click)="clearFile2()" aria-label="Delete" class="mt-2">
                                    <mat-icon>remove_circle</mat-icon>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 text-center mt-40" *ngIf="isFileUploaded">
                <span class="c-dark-grey font-bold fs20"><i class="fas fa-check-circle c-green"></i> File Uploaded Successfully</span>
            </div>
            <div class="col-12 text-center mt-5" *ngIf="uloading === true">
                <span class="loading-message blink">Uploading is in progress...<br />
                    it may take 30 seconds to 1 minute.
                </span>
            </div>
        </div>
    </div>
    <div class="dialog-footer">
        <div class="row" *ngIf="getSubmitBtnVisible() === true && !isFileUploaded">
            <div class="col-5">
                <button mat-raised-button (click)="close()" type="button" ><i class="fas fa-times"></i>&nbsp;Close</button>
            </div>
            <div class="col-7  text-right" >

                <i class="fas fa-arrow-circle-right fs14 c-deep-orange blink"></i>&nbsp;&nbsp; <button mat-raised-button type="submit" color="accent" class="c-white"><i class="fas fa-upload fs16"></i> Upload</button>
            </div>
        </div>
        <div class="row" *ngIf="(getSubmitBtnVisible() === false || isFileUploaded)">
            <div class="col-12 text-center">
                <button mat-raised-button (click)="close()" type="button"><i class="fas fa-times"></i>&nbsp;Close</button>
            </div>
        </div>
    </div>
    <ngx-loading [show]="uloading"></ngx-loading>
   
</form>



<form [formGroup]="iForm" name="iForm" (ngSubmit)="onSubmit()" *ngIf="type === 'Licence'">
    <div class="dialog-body"  [ngClass]="{'xs-dialog-scroll' : size.xs }">

        <div class="row">
            <div class="col-12 mb-3">
                <table>
                    <tr>
                        <td>
                            <span class="bold c-grey fs12">Supported File Formats: &nbsp;&nbsp;<span class="bold c-danger fs12">.PNG, .JPG, .JPEG, .PDF</span></span>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <span class="bold c-grey fs12">Maximum File Size Limit: &nbsp;&nbsp;<span class="bold c-danger fs12">20MB</span></span>
                        </td>

                    </tr>
                </table>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="row" *ngIf="!isFileUploaded">
                    <div class="col-12">
                        <mat-form-field appearance="fill" class="w100" *ngIf="!isFileSelected">
                            <mat-label>Licence Front</mat-label>
                            <ngx-mat-file-input formControlName="file" (change)="onFileSelected($event)" placeholder="Basic fill placeholder" accept="image/*,application/pdf" [disabled]="disabled" #fileUpload required></ngx-mat-file-input>
                            <mat-icon matSuffix *ngIf="fileUpload.empty">folder</mat-icon>
                        </mat-form-field>
                    </div>
                    <div class="col-12 mb-5" *ngIf="isFileSelected">
                        <div class="row">
                            <div class="col-12 text-center">
                                <span class="fs16 bold c-gray-9">Front side of Driver Licence</span>
                            </div>
                            <div class="col-3">
                                <button mat-icon-button color="warn" type="button" (click)="clearFile()" aria-label="Delete" class="mt-2">
                                    <mat-icon>delete forever</mat-icon>
                                </button>
                            </div>
                            <div class="col-9">
                                <img *ngIf="isImageSelected" [src]="filePreviewUrl" alt="Selected Image" style="height: 70px !important;" />
                                <img *ngIf="isPdfSelected" src="assets/images/pdf-logo.png" alt="PDF Icon" style="height: 70px !important;" />
                            </div>
                        </div>
                    </div>

                    <div class="col-12">
                        <mat-form-field appearance="fill" class="w100" *ngIf="!isFileSelected2">
                            <mat-label>Licence Back</mat-label>
                            <ngx-mat-file-input formControlName="file2" (change)="onFileSelected2($event)" placeholder="Basic fill placeholder" accept="image/*,application/pdf" [disabled]="disabled" #fileUpload2 required></ngx-mat-file-input>
                            <mat-icon matSuffix *ngIf="fileUpload2.empty">folder</mat-icon>
                        </mat-form-field>
                    </div>
                    <div class="col-12 mb-5" *ngIf="isFileSelected2">
                        <div class="row">
                            <div class="col-12 text-center">
                                <span class="fs16 bold c-gray-9">Back side of Driver Licence</span>
                            </div>
                            <div class="col-3">
                                <button mat-icon-button color="warn" type="button" (click)="clearFile2()" aria-label="Delete" class="mt-2">
                                    <mat-icon>delete forever</mat-icon>
                                </button>
                            </div>
                            <div class="col-9">
                                <img *ngIf="isImageSelected2" [src]="filePreviewUrl2" alt="Selected Image" style="height: 70px !important;" />
                                <img *ngIf="isPdfSelected2" src="assets/images/pdf-logo.png" alt="PDF Icon" style="height: 70px !important;" />
                            </div>
                        </div>
                    </div>
                    <!-- <div class="col-md-12 text-center" *ngIf="isFileSelected && isFileSelected2">
                        <div style="width:100%;">
                            <span class="c-green bold">Press below button to finish upload. </span> <br />
                            <i class="fas fa-arrow-circle-down fs14 c-deep-orange blink"></i>
                        </div>
                    </div>
                    <div class="col-md-12 text-center" *ngIf="isFileSelected && isFileSelected2">
                        <button mat-raised-button type="submit" color="accent" class="c-white" style="margin-top:15px;"><i class="fas fa-upload fs16"></i> Upload</button>
                    </div> -->
                </div>
            </div>


            <div class="col-md-12 text-center" *ngIf="isFileUploaded">
                <span class="c-dark-grey fs20"><i class="fas fa-check-circle c-green"></i> File Uploaded
                    Successfully</span>
            </div>
        </div>


    </div>
    <div class="dialog-footer">
        <div class="row">
            <div class="col-5">
                <button mat-raised-button (click)="close()"><i class="fas fa-times"></i>&nbsp;Close</button>
            </div>
            <div class="col-7  text-right" *ngIf="isFileSelected && isFileSelected2">

                <i class="fas fa-arrow-circle-right fs14 c-deep-orange blink"></i>&nbsp;&nbsp; <button mat-raised-button type="submit" color="accent" class="c-white"><i class="fas fa-upload fs16"></i> Upload</button>
            </div>
        </div>
    </div>
    <ngx-loading [show]="uloading"></ngx-loading>
    <div class="load-container" *ngIf="uloading === true">
        <span class="loading-message blink">Uploading is in progress...<br />
            it may take 30 seconds to 1 minute.
        </span>
    </div>
</form>


<form [formGroup]="iForm" name="iForm" (ngSubmit)="onSubmit()" *ngIf="type === 'Photo ID' || type === 'Non Photo ID' || type === 'Non Photo ID 2'">
    <div class="dialog-body"  [ngClass]="{'xs-dialog-scroll' : size.xs }">

        <div class="row">
            <div class="col-12 mb-3">
                <table>
                    <tr>
                        <td>
                            <span class="bold c-grey fs12">Supported File Formats: &nbsp;&nbsp;<span class="bold c-danger fs12">.PNG, .JPG, .JPEG, .PDF</span></span>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <span class="bold c-grey fs12">Maximum File Size Limit: &nbsp;&nbsp;<span class="bold c-danger fs12">20MB</span></span>
                        </td>

                    </tr>
                </table>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="row" *ngIf="!isFileUploaded">
                    <div class="col-12">
                        <mat-form-field appearance="fill" class="w100" *ngIf="!isFileSelected">
                            <mat-label>Select Photo ID File</mat-label>
                            <ngx-mat-file-input formControlName="file" (change)="onFileSelected($event)" placeholder="Basic fill placeholder" accept="image/*,application/pdf" [disabled]="disabled" #fileUpload required></ngx-mat-file-input>
                            <mat-icon matSuffix *ngIf="fileUpload.empty">folder</mat-icon>
                        </mat-form-field>
                    </div>
                    <div class="col-12 mb-5" *ngIf="isFileSelected">
                        <div class="row">
                            <div class="col-3">
                                <button mat-icon-button color="warn" type="button" (click)="clearFile()" aria-label="Delete" class="mt-2">
                                    <mat-icon>delete forever</mat-icon>
                                </button>
                            </div>
                            <div class="col-9">
                                <img *ngIf="isImageSelected" [src]="filePreviewUrl" alt="Selected Image" style="height: 70px !important;" />
                                <img *ngIf="isPdfSelected" src="assets/images/pdf-logo.png" alt="PDF Icon" style="height: 70px !important;" />
                            </div>
                        </div>
                    </div>
                    <!-- <div class="col-md-12 text-center" *ngIf="isFileSelected">
                        <div style="width:100%;">
                            <span class="c-green bold">Press below button to finish upload. </span> <br />
                            <i class="fas fa-arrow-circle-down fs14 c-deep-orange blink"></i>
                        </div>
                    </div>
                    <div class="col-md-12 text-center" *ngIf="isFileSelected">
                        <button mat-raised-button type="submit" color="accent" class="c-white" style="margin-top:15px;"><i class="fas fa-upload fs16"></i> Upload</button>
                    </div> -->
                </div>
            </div>
            <div class="col-md-12 text-center" *ngIf="isFileUploaded">
                <span class="c-dark-grey fs20"><i class="fas fa-check-circle c-green"></i> File Uploaded
                    Successfully</span>
            </div>
        </div>


    </div>
    <div class="dialog-footer">
        <div class="row">
            <div class="col-5">
                <button mat-raised-button (click)="close()"><i class="fas fa-times"></i>&nbsp;Close</button>
            </div>
            <div class="col-7  text-right" *ngIf="isFileSelected">

                <i class="fas fa-arrow-circle-right fs14 c-deep-orange blink"></i>&nbsp;&nbsp; <button mat-raised-button type="submit" color="accent" class="c-white"><i class="fas fa-upload fs16"></i> Upload</button>
            </div>
        </div>
    </div>
    <ngx-loading [show]="uloading"></ngx-loading>
    <div class="load-container" *ngIf="uloading === true">
        <span class="loading-message blink">Uploading is in progress...<br />
            it may take 30 seconds to 1 minute.
        </span>

    </div>

</form>

<div *ngIf="type === 'other'">
    <div class="dialog-body"  [ngClass]="{'xs-dialog-scroll' : size.xs }">

        <div class="row">
            <div class="col-12 text-center">
                <button *ngIf="selectedFiles.length === 0" class="btn btn-secondary btn-sm bold w100" type="button" (click)="fileInput.click()" matRipple>
                    <span class=""> Select File</span>
                    <input #fileInput type="file" (change)="selectMultipleFiles($event)" accept="image/*,application/pdf" multiple required style="display:none;" />

                </button>
                <div *ngFor="let item of fileInfos;" class="vex-mail-compose-attachment mb-2 rounded-full border px-4 flex items-center hover:bg-hover transition duration-200 ease-in-out cursor-pointer relative">
                    <mat-icon *ngIf="item.ext === '.pdf'" size="18px">picture_as_pdf</mat-icon>
                    <mat-icon *ngIf="item.ext === '.png' || item.ext === '.jpg' || item.ext === '.jpeg' || item.ext === '.gif' || item.ext === '.tiff'" size="18px">insert_photo</mat-icon>
                    <mat-icon *ngIf="item.ext !== '.pdf' && item.ext !== '.png' && item.ext !== '.jpg' && item.ext !== '.jpeg' && item.ext !== '.gif' && item.ext !== '.tiff'" size="18px">insert_drive_file</mat-icon>
                    <div class="flex-none ml-2 text-sm" style="padding-top: 6px;">
                        <span class="stripped bold" style="max-width: 160px !important;">{{item.name.replace(item.ext, '') |
                            stripHtml}}</span> <span class="stripped bold">{{item.ext}}</span>
                    </div>
                    <span class="flex-1"></span>
                    <div class="progress" style="width: 100px; height: 10px;">
                        <div *ngIf="item.hasError !== true" class="progress-bar progress-bar-striped  bg-success" role="progressbar" attr.aria-valuenow="{{ item.progress }}" aria-valuemin="0" aria-valuemax="100" [ngStyle]="{ width: item.progress + '%' }">
                            {{ item.progress }}%
                        </div>
                        <div *ngIf="item.hasError === true" class="progress-bar progress-bar-striped  bg-danger" role="progressbar" attr.aria-valuenow="{{ item.progress }}" aria-valuemin="0" aria-valuemax="100" [ngStyle]="{ width: item.progress + '%' }">
                            ERROR
                        </div>
                    </div>
                    <div class="text-sm text-gray mr-3 flex-none text-right bold" style="width: 100px;">{{item.size}}</div>
                </div>
            </div>

        </div>



    </div>
    <div class="dialog-footer text-center">
        <div class="row">
            <button mat-raised-button (click)="close()"><i class="fas fa-times"></i>&nbsp;Close</button>
        </div>
    </div>
    <ngx-loading [show]="uloading"></ngx-loading>
    <div class="load-container" *ngIf="uloading === true">
        <span class="loading-message blink">Uploading is in progress...<br />
            it may take 30 seconds to 1 minute.
        </span>

    </div>
</div>



<!-- 
<div class="dialog-footer">
    <div class="row">
        <div class="col-5">

        </div>
        <div class="col-7  text-right">
            <button mat-raised-button (click)="close()"><i class="fas fa-times"></i>&nbsp;Close</button>
        </div>
    </div>
</div> -->